import { styled as muiStyled } from '@mui/material/styles';
import styled, { css } from 'styled-components';

import { FONT_SIZE_TO_LETTER_SPACING_RATIO } from 'components/b2c/Mp3KbpPlayer/Mp3KbpPlayer.constants';
import { fontFamily } from 'stylesheet';
import { colorUsage, getSpacing } from 'stylesheetB2c';
// Elements displayed inside the mp3KbpPlayer
// must be resized proportionally to the videoArea.
// We define here their sizes as a ratio to the
// height of the videoArea.
export const SIZING_FACTORS = {
  titleFontSize: 1 / 10,
  writersFontSize: 1 / 23,
  publishersFontSize: 1 / 19,
};
const MENTION_SLIDE_CONTAINER_LATERAL_PADDING_IN_PERCENT = 2;
const MENTION_SLIDE_TEXT_Z_INDEX = 1;
const MENTION_SLIDE_CONTENT_DEFAULT_Z_INDEX = 0;

// we use a ratio slightly inferior to the one defined in Mp3KbpPlayer constants here
// because the "/" character appears fully black with the Mp3KbpPlayer outline width
const FONT_SIZE_TO_OUTLINE_WIDTH_RATIO = 1 / 7;
const SLIDE_OPACITY_TRANSITION_LENGTH_IN_SECONDS = 0.5;

interface MentionSlideContainerProps {
  isVisible: boolean;
}

export const MentionSlideContainer = styled.div<MentionSlideContainerProps>`
  ${({ isVisible }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 ${MENTION_SLIDE_CONTAINER_LATERAL_PADDING_IN_PERCENT}%;
    opacity: ${isVisible ? 1 : 0};
    transition: opacity ${SLIDE_OPACITY_TRANSITION_LENGTH_IN_SECONDS}s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: ${fontFamily.lyrics};
  `}
`;
MentionSlideContainer.displayName = 'MentionSlideContainer';

interface MentionSlideTextProps {
  fontSizeNumber: number;
  textContent: string;
  marginBottom?: boolean;
}

export const MentionSlideText = muiStyled('div')<MentionSlideTextProps>(
  ({ fontSizeNumber, textContent, marginBottom }) => ({
    position: 'relative',
    fontSize: `${fontSizeNumber}px`,
    letterSpacing: `${fontSizeNumber * FONT_SIZE_TO_LETTER_SPACING_RATIO}px`,
    zIndex: MENTION_SLIDE_TEXT_Z_INDEX,
    width: '100%',
    textAlign: 'center',
    marginBottom: marginBottom ? getSpacing(4) : 0,
    textTransform: 'capitalize',
    '&::before': {
      content: `"${textContent}"`,
      position: 'absolute',
      WebkitTextStroke: `${fontSizeNumber * FONT_SIZE_TO_OUTLINE_WIDTH_RATIO}px
        ${colorUsage.mp3KbpPlayer.lyricsOutline}`,
      width: '100%',
      left: 0,
      bottom: 0,
      zIndex: MENTION_SLIDE_CONTENT_DEFAULT_Z_INDEX - 1,
    },
  }),
);

export const TitleContainer = styled.div`
  width: 100%;
  margin-bottom: 2.5%;
`;
TitleContainer.displayName = 'TitleContainer';

export const WritersOrPublishersContainer = styled.div`
  width: 100%;
  margin-bottom: 0.05%;
  white-space: normal;
`;
WritersOrPublishersContainer.displayName = 'WritersOrPublishersContainer';
